import React from 'react';
import { useUser } from '@/hooks/useUser';
import { JurisdictionsPanel } from '@/components/admin/JurisdictionsPanel';
import { usePageTitle } from '@/hooks/usePageTitle';

export const JurisdictionWorkspacesPage: React.FC = () => {
  usePageTitle('Jurisdictions');
  const { user } = useUser();
  const canEdit = user?.role === 'SYSTEM_ADMIN';

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Jurisdictions</h1>
          <p className="mt-0.5 text-sm text-gray-500">
            Manage jurisdiction hierarchy — states, counties, cities. Each data
            source must be linked to a jurisdiction for proper scoping and
            entitlement enforcement.
          </p>
        </div>
      </div>
      <JurisdictionsPanel canEdit={canEdit} />
    </div>
  );
};
